import verge from "verge";

import Component from "../../component";
import TogglerComponent from "./toggler_component";
import StageComponent from "./stage_component";
import BodyComponent from "./body_component";

const NavMenuConfig = {
    signature: 'NavMenu',
    baseHtmlClass: 'nav_menu',
    selector: '.nav_menu',
    positionDatasetKey: 'nav_menu_position',
    modalMaxWidth: 500
};

export default class NavMenu extends Component {
    constructor(id_or_element) {
        super({
            element: id_or_element,
            config: NavMenuConfig
        });

        this.position = this.readPosition();
        this.open = false; // Is the NavMenu currently open
        this.opening = false; // Is the NavMenu in the process of opening.
        this.closing = false; // Is the NavMenu in the process of closing.
        this.inited = true;

        this.storeScrollPosition();

        // Whenever these sub-components alters state (on this NavMenu) it also calls navMenu.render().
        this.togglerComponents = TogglerComponent.newMany(this);
        this.stageComponent = StageComponent.new(this);
        this.bodyComponent = BodyComponent.new(this);

        this.handleModalState();
        this.resizeTimeout = null;
        window.addEventListener('resize', this.resizeThrottler.bind(this));


        this.render();
    }

    resizeThrottler(event) {
        // ignore events as long as an execution is in the queue
        if ( !this.resizeTimeout ) {
            this.resizeTimeout = setTimeout(function() {
                this.resizeTimeout = null;
                this.handleResize(event);
            }.bind(this), 500);
        }
    }

    handleResize(event) {
        this.handleModalState();
        this.render();
    }

    handleModalState() {
        this.modal = this.isViewportModalSized();
    }

    isViewportModalSized() {
        return ( verge.viewportW() <= NavMenuConfig.modalMaxWidth );
    }

    renderBodyComponent() {
        if (this.bodyComponent) this.bodyComponent.render();
    }

    readPosition() {
        return this.element.dataset[NavMenuConfig.positionDatasetKey] || null;
    }

    storeScrollPosition() {
        this.scrollY = window.scrollY;
        this.scrollX = window.scrollX;
    }

    renderTogglerComponents() {
        this.togglerComponents.forEach((togglerComponent)=> togglerComponent.render());
    }

    renderStageComponent() {
        if (this.stageComponent) this.stageComponent.render();
    }

    // This render method is responsible for rendering all sub components and self NavMenu.
    render() {
        this.renderTogglerComponents();
        this.renderStageComponent();
        this.renderBodyComponent();

        this.conditionallySetHtmlClassState(this.state().inited, 'inited');
        this.conditionallySetHtmlClassState(this.state().open, 'open');
        this.conditionallySetHtmlClassState(this.state().closed, 'closed');
        this.conditionallySetHtmlClassState(this.state().modal, 'modal');
    }

    state() {
        return {
            inited: this.inited,
            open: this.open,
            opening: this.opening,
            closed: !this.open,
            closing: this.closing,
            position: this.position,
            modal: this.modal
        }
    }

}